export const PhoneCallIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8049_5119)">
        <path
          d="M7.1001 8.1305C5.64429 7.51409 4.48662 6.35373 3.8736 4.8965L5.5736 3.1935L2.4436 0.061L0.858098 1.646C0.583098 1.92257 0.365671 2.25093 0.218397 2.61208C0.0711234 2.97322 -0.00307411 3.35999 9.75507e-05 3.75C9.75507e-05 7.374 4.6261 12 8.2501 12C8.64007 12.0034 9.02683 11.9293 9.38792 11.782C9.74902 11.6347 10.0773 11.4172 10.3536 11.142L11.9391 9.5565L8.8066 6.424L7.1001 8.1305ZM9.6461 10.435C9.46248 10.617 9.2445 10.7607 9.00484 10.8577C8.76518 10.9547 8.50862 11.0031 8.2501 11C5.1336 11 1.0001 6.8665 1.0001 3.75C0.997153 3.49142 1.04558 3.23482 1.14257 2.9951C1.23956 2.75537 1.38318 2.53729 1.5651 2.3535L2.4436 1.475L4.1621 3.1935L2.6946 4.661L2.8171 4.968C3.17772 5.93266 3.74148 6.80853 4.47017 7.53627C5.19887 8.26402 6.07547 8.82663 7.0406 9.186L7.3436 9.3015L8.8066 7.838L10.5251 9.5565L9.6461 10.435ZM7.0001 1V0C8.32573 0.0014558 9.59666 0.528708 10.534 1.46607C11.4714 2.40344 11.9986 3.67436 12.0001 5H11.0001C10.9989 3.9395 10.5771 2.92278 9.82721 2.17289C9.07732 1.423 8.0606 1.00119 7.0001 1V1ZM7.0001 3V2C7.7955 2.00079 8.5581 2.31712 9.12054 2.87956C9.68298 3.44199 9.9993 4.20459 10.0001 5H9.0001C9.0001 4.46957 8.78938 3.96086 8.41431 3.58579C8.03924 3.21071 7.53053 3 7.0001 3Z"
          fill="#481DD6"
        />
      </g>
      <defs>
        <clipPath id="clip0_8049_5119">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
